import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IReelStartSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {GGParsedGameData} from "../server/data/GGParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GGParsedInitData} from "../server/data/GGParsedInitData";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {AvalancheReelController} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheReelController";
import {GGReelPartAnimator} from "./GGReelPartAnimator";
import {TimelineLite} from "gsap";
import {GGGameConfig} from "../GGGameConfig";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GGReelSymbol} from "../symbols/GGReelSymbol";
import {GGReelView} from "./GGReelView";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class GGReelController extends AvalancheReelController {

    public static readonly startSize:number = 3;
    public static readonly highWinSymbols:string[] = ["S", "B", "Z"];

    public static readonly SYM_SIZE:{ [reelSize:number]:{ height:number, padding:number } } = {
        1 : {height : 540, padding : 0},
        3 : {height : 180, padding : 0},
        4 : {height : 135, padding : 0},
        5 : {height : 108, padding : 0},
        6 : {height : 90, padding : 0},
        7 : {height : 77, padding : 0.7}
    };

    private _gameAreaSize:number;
    private _scatterNum:number;
    private _reelSizeBefore:number;
    private _doubleBombSpins:number = -1;
    private _wasFeatureBuy:boolean = false;
    private _hasWin:boolean = false;
    private _hadWin:boolean = false;
    private _isFS:boolean = false;
    private _isAvalanche:boolean = false;
    private _dwNr:number[] = [];
    private _scatterNr:number[] = [];
    private _dwNrAfterCollapse:number = 0;
    private _scatterNrAfterCollapse:number = 0;

    get isScatterAnticipation():boolean {
        if(this.reelId === 0 || this.reelId === 5) {
            return false;
        }
        if(this._doubleBombSpins === -1 && this._wasFeatureBuy && (this._gameMode === GameMode.NORMAL_AVALANCHE || this._gameMode === GameMode.NORMAL)) {
            return false;
        }
        return (this._scatterNr[this._reelId] < 4 && this._scatterNr[this._reelId] > 1);
    }

    get isDeadWildAnticipation():boolean {
        if(this.reelId === 0) {
            return false;
        }
        return (this._dwNr[this._reelId] > 2);
    }

    constructor(reelId:number) {
        super(reelId);
    }

    protected onInitDataParsed(data:GGParsedInitData):void {
        this._wasFeatureBuy = data.wasFeatureBuy;
        this._doubleBombSpins = data.doubleBombSpins;
        this._isFS = data.isFreespinRestore;
        this._gameAreaSize = data.gameAreaSize;
        this._reelSizeBefore = this._gameAreaSize;
        this.initAnimator();
        super.onInitDataParsed(data);
        if(data.isRestoreState && this.isNextAvalanche()) {
            this._hasWin = true;
        }
        this._isAvalanche = this.isAvalanche();
        this._dwNr = [];
        this._scatterNr = [];
        let dwNr:number = 0;
        let scatterNr:number = 0;
        data.reelsAfterCollapse.forEach((symbols:string[]) => {
            this._dwNr.push(dwNr);
            this._scatterNr.push(scatterNr);
            symbols.forEach((symbol:string) => {
                if(symbol === "Z") {
                    dwNr++;
                } else if(symbol === "S") {
                    scatterNr++;
                }
            });
        });
        this._dwNrAfterCollapse = dwNr;
        this._scatterNrAfterCollapse = scatterNr;
    }

    public onGameDataParsed(data:GGParsedGameData):void {
        this._dwNr = [];
        this._scatterNr = [];
        this._reelSizeBefore = this._gameAreaSize;
        super.onGameDataParsed(data);
        this._gameAreaSize = data.gameAreaSize;
        this._isAvalanche = data.isAvalancheMode;
        this._isFS = data.isFreespinMode;
        this._wasFeatureBuy = data.wasFeatureBuy;
        this._doubleBombSpins = data.doubleBombSpins;
        if(!this._isAvalanche) {
            this._reelSizeBefore = GGReelController.startSize;
        }
        this._hadWin = this._hasWin;
        this._hasWin = (this._allWinPositions.includes(true) || data.xBombs.bomb);
        this._scatterNum = data.numberOfScatters - data.numberOfScattersBefore;
        const numOffset:number = GGGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - this._gameAreaSize;
        for(let i:number = 0; i < numOffset; i++) {
            if(this._hasWin) {
                this._allWinPositions[i] = true;
            }
            if(this._hadWin) {
                this._newSymbols.unshift("X");
            }
        }
        if(data.isAvalancheMode) {
            let dwNr:number = 0;
            let scatterNr:number = 0;
            data.newSymbols.forEach((symbols:string[], i:number) => {
                this._dwNr.push(dwNr + this._dwNrAfterCollapse);
                this._scatterNr.push(scatterNr + this._scatterNrAfterCollapse);
                symbols.forEach((symbol:string) => {
                    if(symbol === "Z") {
                        dwNr++;
                    } else if(symbol === "S") {
                        scatterNr++;
                    }
                });
            });
        } else {
            this._dwNr = data.deadWildsOnReel;
            this._scatterNr = data.scattersOnReel;
        }
        this._dwNrAfterCollapse = data.deadWildsOnReelAfterCollapse;
        this._scatterNrAfterCollapse = data.scattersOnReelAfterCollapse;
    }

    protected initAnimator():void {
        const reelSize = this._reelSizeBefore;
        this._reelPartAnimator.symWidth = GameConfig.instance.SYMBOL_WIDTH;
        this._reelPartAnimator.symBottomPadding = GGReelController.SYM_SIZE[reelSize].padding;
        this._reelPartAnimator.symHeight = GGReelController.SYM_SIZE[reelSize].height;
    }

    protected onStopDelayDone():void {
        this._currentReelSet = this.makeUpStopReelSet(0, false);
        this._currentReelSetPosition = this._currentReelSet.length;

        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => this.onSpinStopStarted());
        if(this._isAvalanche) {
            this._currentState = ReelAnimationState.AVALANCHE_NEW;
        } else {
            this._currentState = ReelAnimationState.ALL_IN;
        }
        timeline.add(() => {
            this.reArrangeSymbolZIndex();
        }, 0);
        timeline.add((<GGReelPartAnimator>this._avalancheReelPartAnimator).ggGetNewSymbolsInAnimation(this.getGGNewSymbols(), this._nearWinPositions[this.reelId]));
        timeline.add(() => this.onSpinStopAnimationCompleted());
        this._stopTimeline = timeline;

        if(this.reelId < GameConfig.instance.REELS_NUM - 1) {
            const nextReelId:number = this.reelId + 1;
            // TODO: quick fix for Dragon, need to get a better solution for slot-game.
            let nextDelay:number = this.getReelStopOffset(nextReelId);
            if((<GGReelController>Reels.getReel(nextReelId)).shouldPlayNearWinStop()) {
                const currentDuration:number = this._avalancheReelPartAnimator.currentTimeline ? this._avalancheReelPartAnimator.currentTimeline!.totalDuration() : 0;
                nextDelay = Math.max(0, currentDuration + nextDelay);
            }
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_REFRESH_STOP_DELAY, {
                reelId : nextReelId,
                delay : nextDelay
            }));
        }
    }

    protected initReelStrip():void {
        super.initReelStrip();
        this.reArrangeSymbolZIndex();
    }

    private reArrangeSymbolZIndex():void {
        const scatters:GGReelSymbol[] = []
        if(this.allSymbols) {
            (<GGReelSymbol[]>this.allSymbols).forEach((sym:GGReelSymbol) => {
                if(GGReelController.highWinSymbols.indexOf(sym.symName) > -1) {
                    scatters.push(sym)
                }
                this._reelView.addChild(sym);
            });
            scatters.forEach((sym:GGReelSymbol) => {
                this.liftSymbol(sym);
            });
        }
    }

    public liftSymbol(sym:GGReelSymbol):void {
        this._reelView.addChild(sym);
        this._reelView.parent.addChild(this._reelView);
    }

    private getGGNewSymbols():StateReelSymbol[] {
        const result:StateReelSymbol[] = [];
        let previousSymbol:StateReelSymbol | null = null;
        while(this._currentReelSetPosition > 0) {
            const newSymbol:StateReelSymbol = this.createNextSymbol(previousSymbol);
            //Logger.logDev(`Reel ${this.reelId} got new symbol ${newSymbol.symName}`);
            result.unshift(newSymbol);
            previousSymbol = newSymbol;
        }
        return result;
    }

    protected addNewSymbol(symName:string, state?:ISymbolStateConfig):StateReelSymbol {
        if(state == null) {
            state = GameConfig.instance.SYMBOL_STATES.normal;
        }

        const symbol:StateReelSymbol = this._reelPartCreator.createNewSymbol(symName, this._reelId, state, {
            width : this._reelPartAnimator.symWidth,
            height : this._reelPartAnimator.symHeight,
            bottomPadding : this._reelPartAnimator.symBottomPadding
        });
        symbol.x = 0;
        symbol.y = -symbol.symHeight / 2 - GameConfig.instance.REEL_AREA_POS_Y - GameConfig.instance.REEL_DISPLAY_POSITIONS[this._reelId][1]; // this is just a temp position that's not visible. this position might be visible in portrait mode but it doesn't matter. the position will be updated when put the symbol to the animator.
        this._reelView.addChild(symbol);

        return symbol;
    }

    public addTransformedSymbol(symName:string):StateReelSymbol {
        const newSymbol:StateReelSymbol = this.addNewSymbol(symName);
        return newSymbol;
    }

    public removeTransformedSymbol(newSymbol:StateReelSymbol, symId:number):void {
        const oldSymbol = this.allSymbols.splice(symId, 1, newSymbol)[0];
        newSymbol.position.set(oldSymbol.x, oldSymbol.y);
        (<GGReelView>this._reelView).addSymbolToWinContainer(newSymbol);
        this._reelView.removeChild(oldSymbol);
        this._reelPartCreator.deleteSymbol(oldSymbol);
    }

    protected setStartSpinData(data:IReelStartSpinData):void {
        super.setStartSpinData(data);
        if(!this.isAvalanche()) {
            (<GGReelPartAnimator>this._reelPartAnimator).resetSize(GGReelController.SYM_SIZE[GGReelController.startSize].height, false);
        }
    }

    public resetSizeAfterBomb(reelSize:number, bombArea:boolean[]):void {
        this._reelSizeBefore = reelSize;
        (<GGReelPartAnimator>this._reelPartAnimator).resetSizeAfterBomb(GGReelController.SYM_SIZE[reelSize].height, bombArea);
        this.initAnimator();
    }

    public updateSize(reelSize:number):void {
        this._reelSizeBefore = reelSize;
        (<GGReelPartAnimator>this._reelPartAnimator).resetSize(GGReelController.SYM_SIZE[reelSize].height, false);
        this.initAnimator();
    }

    public updateSizeAS(reelSize:number):void {
        this._reelSizeBefore = reelSize;
        (<GGReelPartAnimator>this._reelPartAnimator).resetSize(GGReelController.SYM_SIZE[reelSize].height, true);
        this.initAnimator();
        this.reArrangeSymbolZIndex();
    }


    public shouldPlayNearWinStop():boolean {
        if(this._reelPartAnimator.isQuickStop) {
            return false;
        }
        const hasNearWin:boolean = (this.isScatterAnticipation || this.isDeadWildAnticipation);
        return hasNearWin; // #391 #521
    }

    protected getNearWinStopDelay(reelId:number):number {
        // #521 -> not anticipation for 2 dead wilds(if there is no scatter anticipation happening), server says to anticipate, but we don't want it.
        if(!this.isScatterAnticipation && !this.isDeadWildAnticipation) {
            return 0;
        }
        // #529, turn off scatter anticipation for last reel if deadWilds are not anticipating.
        if(reelId === 5 && (this.isScatterAnticipation && !this.isDeadWildAnticipation)) {
            return 0;
        } else {
            return super.getNearWinStopDelay(reelId);
        }
    }

    protected getNormalStopDelay(reelId:number):number {
        if(this._isFS) {
            return GGGameConfig.instance.FS_REEL_STOP_DELAY;
        } else {
            return super.getNormalStopDelay(reelId);
        }

    }

    protected getReelStopOffset(reelId:number):number {
        if(this.isDeadWildAnticipation || this.isScatterAnticipation) {
            return this.getNearWinStopDelay(reelId)
        }

        if(this.isAvalanche() && this._newSymbols.length === 0) {
            return 0;
        }

        if(this._reelPartAnimator.isQuickStop) {
            return this.getQuickStopDelay(reelId);
        }

        if(this._reelPartAnimator.isFastSpin) {
            return this.getFastSpinStopDelay(reelId);
        }

        return this.getNormalStopDelay(reelId);
    }
}